import { render, staticRenderFns } from "./WidgetMailSender.vue?vue&type=template&id=228596c4&scoped=true&"
import script from "./WidgetMailSender.vue?vue&type=script&lang=js&"
export * from "./WidgetMailSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228596c4",
  null
  
)

export default component.exports